import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class vehiculoService {
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}logistica/vehiculo`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
        
    };
    
    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/vehiculo/paginacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}logistica/vehiculo/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorClienteId(id) {
        const response = await axios
            .get(`${ERP}logistica/vehiculo/por-cliente/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/vehiculo/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}logistica/vehiculo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}logistica/vehiculo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}logistica/vehiculo/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async activar(data) {
        const response = await axios
            .put(`${ERP}logistica/vehiculo/activar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
}

export default new vehiculoService();